import { Component, OnInit, ViewEncapsulation } from "@angular/core";

import { environment } from "src/environments/environment";
import { AppSessionService } from "src/app/shared/services/app-session/app-session.service";

@Component({
  selector: "app-about-dialog",
  templateUrl: "./about-dialog.component.html",
  styleUrls: ["./about-dialog.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AboutDialogComponent implements OnInit {
  appVersion = environment?.appVersion;
  envProduction = environment?.production;
  baseApiUrl: string;
  userManualLink = '../../../../../assets/UserManual_Aplicacao_Gestao_Frota_(Fleetsys)_v1.0.docx';

  constructor(
    public session: AppSessionService,
  ) { }

  ngOnInit(): void {
    this.baseApiUrl = this.session.baseUrl + '/api-docs/swagger';
  }
}
